import { SearchMode } from './searchMatch';

const SEARCH_MODE_KEY = 'datascope.searchMode';

/** Fired on the window when the mode changes, so same-tab instances stay in sync
 * (the native `storage` event only fires in *other* tabs). */
export const SEARCH_MODE_EVENT = 'datascope:search-mode-change';

/** Web default: the long-standing literal substring behavior. */
export const DEFAULT_SEARCH_MODE: SearchMode = 'exact';

/**
 * Reads the persisted search mode (global per device). Only the non-default
 * (`'general'`) is ever stored, so anything else — absent, corrupt, or unreadable
 * (private mode) — resolves to the default (`'exact'`).
 */
export const getStoredSearchMode = (): SearchMode => {
  try {
    return localStorage.getItem(SEARCH_MODE_KEY) === 'general'
      ? 'general'
      : DEFAULT_SEARCH_MODE;
  } catch {
    return DEFAULT_SEARCH_MODE;
  }
};

/** Persists the chosen mode. Stores only `'general'`; the default clears the key.
 * Best-effort: write failures (private mode / quota) are ignored. */
export const setStoredSearchMode = (mode: SearchMode): void => {
  try {
    if (mode === 'general') {
      localStorage.setItem(SEARCH_MODE_KEY, 'general');
    } else {
      localStorage.removeItem(SEARCH_MODE_KEY);
    }
  } catch {
    // Persisting the preference is best-effort.
  }
};
